/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_All_BeforeInputs */



/**
* | output |
* | --- |
* | "Select All Before" |
*
* @param {Context_Menu_Select_All_BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all_before = /** @type {((inputs?: Context_Menu_Select_All_BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_All_BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez tout avant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle auswählen, bevor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutto prima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрать все перед")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todo antes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在选择之前全部选中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて選択する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione tudo antes de")
	return /** @type {LocalizedString} */ ("Select All Before")
});